import isEmpty from 'lodash/isEmpty';
import { APIErrors } from '../../models/errors/actions/ApiErrors';

export function shouldDispatchGenericError(res, store) {
    if (res?.status === 200) return false;

    const env = store.env;
    const errorsStore = env?.errorsStore;

    if (shouldHandleAsStatusError(res, store)) return true;

    if (!isEmpty(res?.code)) {
        if (env && errorsStore) {
            const errorData = {
                ...res.response?.data?.errors?.[0],
                code: res.code,
                traceId: env.traceId,
            };
            errorsStore.dispatch(errorData);
        }
        return true;
    }

    return false;
}

const errorsStatusMap = {
    error404: APIErrors.Error404,
    error500: APIErrors.Error500,
};

function shouldHandleAsStatusError(res, store) {
    const env = store.env;
    const errorsStore = env?.errorsStore;

    if (isEmpty(res?.response)) return false;

    const error = errorsStatusMap[`error${res.response.status}`];
    if (error) {
        errorsStore?.dispatch(error);
        return true;
    }
    return false;
}
